import { ReactNode, useEffect, useRef } from 'react';

import { Card } from 'apps/shared/scripts/__generated__/graphql.generated';

import { cardPreviewDesignClassName } from './styles';

interface Props {
  children: ReactNode;
  design: Card['design'];
}

const CardPreviewDesign = ({ children, design }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!design || !ref.current) {
      return;
    }
    const { color, background } = design;
    ref.current.style.setProperty('--card-color-accent', color);
    ref.current.style.background = `url(${background.src})`;
    ref.current.style.backgroundAttachment = background.attachment;
    ref.current.style.backgroundSize = background.size;
  }, [design]);

  return (
    <div className={cardPreviewDesignClassName} ref={ref}>
      {children}
    </div>
  );
};

CardPreviewDesign.displayName = 'CardPreviewDesign';

export default CardPreviewDesign;
